import { Nullable } from '@application/Types/Opt'
import { POPEYE_URL } from '@src/Core/Constants/RouteConstants'
import { ensureForwardSlash } from '@src/Infrastructure/Url/ensureForwardSlash'

export const openExternalUrl = (url: string, newTab = true): Nullable<Window> =>
    window.open(url, newTab ? '_blank' : '_self')

export const getDomain = (input: string): string => {
    try {
        return new URL(input).host.replace('www.', '')
    } catch {
        return ''
    }
}

export const isRelativeUrl = (url: string): boolean => ensureForwardSlash(url).startsWith('/')

export const isPopeyeUrl = (url: string): boolean => getDomain(url) === getDomain(POPEYE_URL)

export const isInternalUrl = ({ url, siteUrl }: { url: string; siteUrl: string }): boolean =>
    getDomain(url) === getDomain(siteUrl) || isPopeyeUrl(url)
